<template>
  <ConfirmModal ref="modal" :disabled-ok-button="isCalculated && !mode">
    <div v-if="isCalculated" class="mt-2 flex flex-col gap-3">
      <label
        v-for="option in options"
        :key="option.mode"
        class="flex cursor-pointer items-start gap-3 rounded-md border border-slate-300 p-3 text-left dark:border-slate-500"
        :class="{ 'border-primary bg-primary-50': mode === option.mode }"
      >
        <input
          v-model="mode"
          type="radio"
          name="commission_note_line_delete_mode"
          :value="option.mode"
          class="mt-1"
        />
        <span class="flex flex-col">
          <span class="font-semibold">{{ option.title }}</span>
          <span class="text-sm text-gray-500">{{ option.hint }}</span>
        </span>
      </label>
    </div>
  </ConfirmModal>
</template>

<script>
import ConfirmModal from '@c/addf-package/components/modal/ConfirmModal.vue'

/**
 * Asks before removing a line of an open note. A free line is simply deleted;
 * a calculated line (a sale) has two outcomes the user must choose between; a
 * cancelled line is simply deleted too: its document was cancelled, so there is
 * nothing to choose and the document is just let go.
 */
export default {
  name: 'CommissionNoteItemDeleteModal',
  components: { ConfirmModal },
  data() {
    return { mode: null, isCalculated: false, cancelled: false }
  },
  computed: {
    options() {
      return [
        {
          mode: 'release',
          title: this.$t('global.commission_note_line_delete_release'),
          hint: this.$t('global.commission_note_line_delete_release_hint')
        },
        {
          mode: 'exclude',
          title: this.$t('global.commission_note_line_delete_exclude'),
          hint: this.$t('global.commission_note_line_delete_exclude_hint')
        }
      ]
    }
  },
  methods: {
    /**
     * Resolves with the mode to send (`release`, `exclude`; `release` for a
     * cancelled line, nothing to choose), `true` for a free line, or `false` when
     * the user gives up.
     */
    async show(item) {
      this.mode = null
      this.isCalculated = !item.is_free && !item.is_cancelled
      this.cancelled = !!item.is_cancelled

      const confirmed = await this.$refs.modal.show({
        title: this.isCalculated
          ? this.$t('global.commission_note_line_delete_title')
          : this.$t('global.commission_note_line_delete_free_title'),
        // always a message: the confirmation modal keeps the previous one otherwise
        message: this.isCalculated
          ? this.$t('global.commission_note_line_delete_message')
          : this.$t('global.commission_note_line_delete_free_message'),
        okButton: this.$t('button.delete')
      })

      if (!confirmed) {
        return false
      }

      if (this.cancelled) {
        return 'release'
      }

      return this.isCalculated ? this.mode : true
    }
  }
}
</script>
